module.exports = __webpack_public_path__ + "static/c40c28fc42446d895ac6b9f7988f275af151e9652fe4bc269c09b41d33db59da-b98c6d6058e9a6c7c30cfc89fae8f77d.png";